import { Component, AfterViewInit, HostListener, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-course-slider',
  templateUrl: './course-slider.component.html',
  styleUrls: ['./course-slider.component.scss']
})
export class CourseSliderComponent implements AfterViewInit {
  @ViewChild('sliderWrapper') sliderWrapper!: ElementRef;
  @ViewChild('prevBtn') prevBtn!: ElementRef;
  @ViewChild('nextBtn') nextBtn!: ElementRef;

  private index: number = 0;
  private cardsToShow: number = 4;
  private cards: HTMLElement[] = [];

  ngAfterViewInit() {
    this.cards = Array.from(this.sliderWrapper.nativeElement.children);
    this.updateVisibility();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.updateVisibility();
  }

  nextSlide() {
    const totalCards = this.cards.length;
    if (this.index + this.cardsToShow < totalCards) {
      this.index++;
      this.updateVisibility();
    }
  }

  prevSlide() {
    if (this.index > 0) {
      this.index--;
      this.updateVisibility();
    }
  }

  private updateVisibility() {
    const screenWidth = window.innerWidth;
    if (screenWidth < 640) {
      this.cardsToShow = 1;
    } else if (screenWidth < 768) {
      this.cardsToShow = 2;
    } else if (screenWidth < 1024) {
      this.cardsToShow = 3;
    } else if (screenWidth < 1440) {
      this.cardsToShow = 4;
    } else {
      this.cardsToShow = 5;
    }

    this.sliderWrapper.nativeElement.style.transition = 'transform 0.5s ease-in-out';
    this.cards.forEach(card => {
      card.classList.add('hidden');
      card.classList.remove('opacity-100', 'translate-x-0');
    });
    for (let i = this.index; i < this.index + this.cardsToShow && i < this.cards.length; i++) {
      this.cards[i].classList.remove('hidden');
      this.cards[i].classList.add('opacity-100', 'translate-x-0');
    }
  }
}